import { BrandMark, Button, Card } from "@artisan/ui";
import { LogOut } from "lucide-react";

import { type MyOrg, type Session, logout, switchOrg } from "../lib/auth";

/** Roles that may send a survey to the factory (the server's factory WRITE_ROLES). */
const FIELD_ROLES: readonly MyOrg["role"][] = ["owner", "manager", "designer", "sales"];

export function canSurvey(org: MyOrg | null): boolean {
  return org !== null && org.type === "contractor" && FIELD_ROLES.includes(org.role);
}

/** Shown when the active organisation cannot send surveys: switch to one that can, or sign out. */
export function NoAccessScreen({ session }: { session: Session }) {
  const usable = session.orgs.filter(canSurvey);
  return (
    <div className="grid h-full place-items-center bg-background p-8">
      <Card className="w-full max-w-md space-y-5 p-8">
        <BrandMark size={36} labelled={false} />
        <div className="space-y-2">
          <h1 className="font-display text-2xl font-semibold tracking-tight">Энэ апп гүйцэтгэгчдэд зориулагдсан</h1>
          <p className="text-sm text-muted-foreground">
            {usable.length
              ? "Хэмжилт хийх байгууллагаа сонгоно уу."
              : "Хэмжилт илгээхийн тулд гүйцэтгэгч байгууллагад эзэмшигч, менежер, дизайнер эсвэл борлуулагчийн эрхтэй байх хэрэгтэй. Байгууллагынхаа эзэмшигчээс урилга авна уу."}
          </p>
        </div>
        {usable.length ? (
          <div className="grid gap-2">
            {usable.map((o) => (
              <Button key={o.id} variant="outline" size="lg" className="justify-start" onClick={() => void switchOrg(o.id)}>
                {o.name}
              </Button>
            ))}
          </div>
        ) : null}
        <Button variant="ghost" icon={LogOut} onClick={() => void logout()}>
          Гарах
        </Button>
      </Card>
    </div>
  );
}
